<template>
  <div class="container">
    <!-- Contact Information Section -->
    <div class="card contact-card">
      <h2 class="title" style="text-align: left; margin-left: 40px;">Contact information</h2>
      <div class="content">
        <p class="textBlue">
          Dr. Xiangyu Li <br />
          lixiangyu@bjtu.edu.cn<br />
          Room 709, Yifu Building<br />
          School of Software Engineering,<br /> Beijing Jiaotong University, Beijing, China
        </p>
      </div>
    </div>

    <!-- Join Us Section -->
    <div class="card join-card">
      <h2 class="title" style="text-align: left; margin-left: 20px;">Join us now</h2>
      <div class="content">
        <p class="text">
          <span class="highlight"></span>
          We are now looking for self-motivated graduate/undergraduate students.<br />
          If you are interested in and want to join Xiangyu Li Lab at BJTU, feel free to contact us.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JoinUs",
};
</script>

<style scoped>
.container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin: 0 auto; /* 设置水平居中 */
  margin-left: -16px;
}

/* 蓝色模块 */
.card.contact-card {
  background: #005bac;
  color: white;
  padding: 20px;
  width: 50%;
  position: relative;
  z-index: 1;
  margin-left: 43%;
  margin-top: 1%;
}

.card.contact-card::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  background: #62aae8;
  clip-path: polygon(100% 0, 0 0, 100% 100%);
}

.card.contact-card .title {
  text-align: left;
  margin-left: 20px;
  border-bottom: 2px solid white;
}

/* 白色模块 */
.card.join-card {
  background: #fff;
  color: #005bac;
  padding: 20px;
  width: 40%;
  position: absolute;
  top: 30px;
  left: 20px;
  z-index: 2;
  box-shadow: 0 4px 6px rgba(98, 170, 232, 0.3);
  border-radius: 8px;
  border: 2px solid #62aae8;
}

.title {
  font-size: 1.5rem;
  margin-bottom: 10px;
  border-bottom: 2px solid #005bac;
}

.content {
  margin-top: 10px;
}

.text {
  text-align: left;
  margin-left: 20px;
  font-size: 1rem;
  line-height: 1.5;
}
.textBlue{
  text-align: left;
  margin-left: 40px;
  font-size: 1rem;
  line-height: 1.5;
}

/* 在小屏幕情况下的样式调整 */
@media screen and (max-width: 768px) {
  .container {
    display: block; /* 改为垂直布局 */
  }

  .card.contact-card,
  .card.join-card {
    position: relative; /* 重置为相对定位 */
    width: 90%; /* 调整宽度 */
    margin: 10px auto; /* 居中 */
  }

  .card.join-card {
    top: 0; /* 移除顶部位置偏移 */
    left: 0; /* 移除左侧位置偏移 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/JoinUs.vue